
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Experience from './components/Experience';
import Education from './components/Education';
import Portfolio from './components/Portfolio';
import Skills from './components/Skills';
import Tools from './components/Tools';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="bg-gradient-to-br from-[#0a0118] via-[#1a0b2e] to-[#0f0520] min-h-screen text-white">
      <Hero />
      <Services />
      <Experience />
      <Education />
      <Portfolio />
      <Skills />
      <Tools />
      <Contact />
      <Footer />
      
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center shadow-lg shadow-purple-500/50 hover:shadow-purple-500/80 transition-all duration-300 hover:scale-110 z-50 cursor-pointer"
          aria-label="Back to top"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
        </button>
      )}
    </div>
  );
}
